import React, { Component } from 'react';
import PropTypes from 'prop-types';

function isLeftClickEvent(event) {
  return event.button === 0
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey)
}

class Link extends Component {
  constructor(props, context) {
    super(props, context)

    // The `bind` is necessary to make `this` work within the `handleClick`
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick(event) {
    if (event.defaultPrevented ||
        isModifiedEvent(event) ||
        !isLeftClickEvent(event)) {
      return
    }

    event.preventDefault()

    this.context.history.push(this.props.href);
  }

  render() {
    var props = Object.assign({}, this.props);
    props.onClick = this.handleClick;
    return <a {...props}>{props.children}</a>
  }
}

Link.contextTypes = {
  history: PropTypes.object
};

export default Link;



// WEBPACK FOOTER //
// ./src/lib/Link.js